const style = {
  wrapper: {
    maxWidth: 305,
  },
  dropdownWrapper: {
    borderRight: `1px solid #ccc`,
  },
};

export default style;
